import { IsoCountryCode } from './configuration';

export class ItemDescription {
    ItemCode: string;
    Description: string;
    DescriptionEN: string;
}

export class SalesModule {
    ProductID: string;
    SalesModuleShortName: string;
}

export class SupportedCountries {
    CountryCode: string;
    CountryDescription: string;
}
